package com.rajen.angrejidictionary.data.local

import kotlinx.browser.localStorage

object AdminAuthManager {
    private const val TOKEN_KEY = "ad_admin_token"
    private const val USERNAME_KEY = "ad_admin_user"

    fun saveToken(token: String, username: String) {
        localStorage.setItem(TOKEN_KEY, token)
        localStorage.setItem(USERNAME_KEY, username)
    }

    fun getToken(): String? = localStorage.getItem(TOKEN_KEY)

    fun getUsername(): String? = localStorage.getItem(USERNAME_KEY)

    fun isLoggedIn(): Boolean = getToken() != null

    fun logout() {
        localStorage.removeItem(TOKEN_KEY)
        localStorage.removeItem(USERNAME_KEY)
    }
}